import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_ASSEMBLY_LINE_UPDATE_APPLICATION } from 'api/actionTypes';

export default async function updateAssemblyLineApplicationAction(
  { state, apiClient },
  { assemblyLineApplicationId, listingId, updates },
) {
  typeCheck('assemblyLineApplicationId::PositiveNumber', assemblyLineApplicationId);
  typeCheck('listingId::PositiveNumber', listingId);
  typeCheck('updates::NonEmptyObject', updates);

  const assemblyLineData = await apiClient.postWithState({
    action: SR_API_ACTION_ASSEMBLY_LINE_UPDATE_APPLICATION,
    state: state,
    queryId: JSON.stringify(updates),
    payload: {
      assemblyLineApplicationId,
      listingId,
      updates,
    },
    onSuccess(assemblyLineData) {
      state.set(
        ['assemblyLine', 'byHouseholdListings', assemblyLineData.householdListing.id],
        assemblyLineData,
      );
    },
  });

  return assemblyLineData;
}
